import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import { setTeamAccounts } from 'Workspace/Admin/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { teamId } = action;

  const iamTeamAccountSummary = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_IAM_TEAM_ACCOUNT_SUMMARY,
    teamId,
  });
  if (iamTeamAccountSummary.type === constants.RTM_IAM_TEAM_ACCOUNT_SUMMARY_OK) {
    const teamAccounts = iamTeamAccountSummary.response.collaborators;
    yield put(setTeamAccounts(teamId, teamAccounts));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedIamTeamAccountSummaryFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_IAM_TEAM_ACCOUNT_SUMMARY, catchErrors, sendRequest, connection);
}
